import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import DashboardNav from './DashboardNav';
import LogoWithBeta from './LogoWithBeta';
import { LOGO_BETA_WRAPPER_STYLE } from './logoBetaWrapperStyle';
import { LOGO_HEIGHT_NAV_COMPACT } from './logoMarkSizes';
import { DASHBOARD_NAV_WIDTH_PX } from '../designSystem';

export function MobileDashboardHeader({ onMenu }) {
  const navigate = useNavigate();
  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: 'var(--white)',
        borderBottom: '1px solid var(--border)',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        flexShrink: 0,
      }}
    >
      <button
        type="button"
        onClick={() => navigate('/')}
        style={{
          ...LOGO_BETA_WRAPPER_STYLE,
          minWidth: 0,
          border: 'none',
          background: 'none',
          padding: 0,
          cursor: 'pointer',
          font: 'inherit',
        }}
        aria-label="OrivonAI home"
      >
        <LogoWithBeta height={LOGO_HEIGHT_NAV_COMPACT} unwrapped />
      </button>
      <button
        type="button"
        onClick={onMenu}
        aria-label="Open navigation menu"
        style={{
          minWidth: 44,
          minHeight: 44,
          padding: '0 14px',
          borderRadius: 10,
          border: '1px solid var(--border)',
          background: 'var(--sand)',
          fontSize: 14,
          fontWeight: 700,
          color: 'var(--text)',
          cursor: 'pointer',
        }}
      >
        Menu
      </button>
    </header>
  );
}

export function MobileNavDrawer({ onClose }) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  const node = (
    <>
      <button
        type="button"
        aria-label="Close menu"
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(17,17,17,0.4)',
          border: 'none',
          cursor: 'pointer',
          zIndex: 180,
        }}
      />
      <aside
        role="dialog"
        aria-modal="true"
        aria-label="Site navigation"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          minHeight: '100%',
          height: '100dvh',
          paddingTop: 'env(safe-area-inset-top)',
          width: `min(${DASHBOARD_NAV_WIDTH_PX}px, 92vw)`,
          background: 'var(--white)',
          boxShadow: '4px 0 24px rgba(0,0,0,0.12)',
          zIndex: 190,
          overflowY: 'auto',
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 2,
            background: 'var(--white)',
            padding: '10px 10px 8px',
            borderBottom: '1px solid var(--border)',
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              width: '100%',
              padding: '10px',
              fontWeight: 700,
              fontSize: 13,
              border: '1px solid var(--border)',
              borderRadius: 8,
              background: 'var(--sand)',
              cursor: 'pointer',
            }}
          >
            Close menu
          </button>
        </div>
        <DashboardNav embedded />
      </aside>
    </>
  );

  if (typeof document === 'undefined') return null;
  return createPortal(node, document.body);
}
